export enum ChatgptVariantFieldType {
  Sku = "sku",
  Price = "price",
  SalePrice = "sale_price",
  SalePriceEffectiveDate = "sale_price_effective_date",
  UnitPricingMeasure = "unit_pricing_measure",
  BaseMeasure = "base_measure",
  PricingTrend = "pricing_trend",
  Color = "color",
  Size = "size",
  SizeSystem = "size_system",
  Gender = "gender",
  OfferId = "offer_id",
  CustomVariant1Category = "custom_variant1_category",
  CustomVariant1Value = "custom_variant1_value",
  CustomVariant2Category = "custom_variant2_category",
  CustomVariant2Value = "custom_variant2_value",
  CustomVariant3Category = "custom_variant3_category",
  CustomVariant3Value = "custom_variant3_value",
}
